import { ref } from "vue";
export const notification = ref(""),
  dialog = ref(null);
let timer;
const queue = [];
export function notify(message) {
  notification.value = String(message?.message || message || "");
  clearTimeout(timer);
  timer = setTimeout(() => (notification.value = ""), 3000);
}
function next() {
  if (!dialog.value && queue.length) dialog.value = queue.shift();
}
function open(kind, message, options) {
  return new Promise((resolve) => {
    queue.push({
      kind,
      message,
      title: "提示",
      confirmText: "确定",
      cancelText: "取消",
      value: "",
      ...options,
      resolve,
    });
    next();
  });
}
export function confirmAction(message, options = {}) {
  return open("confirm", message, options);
}
export function promptAction(message, options = {}) {
  return open("prompt", message, options);
}
export function answerDialog(confirmed) {
  const current = dialog.value;
  if (!current) return;
  dialog.value = null;
  current.resolve(
    current.kind === "prompt"
      ? confirmed
        ? current.value
        : null
      : Boolean(confirmed),
  );
  next();
}
